import { useQuery } from '@tanstack/react-query';
import { getProductOptionById } from '../../../../api/product-option/queries/getProductOptionById';

interface IUseGetProductOptionById {
  productId: string;
}

export const useGetProductOptionById = ({ productId }: IUseGetProductOptionById) =>
  useQuery(['product_option_by_id', productId], () => getProductOptionById({ productId }), {
    enabled: Boolean(productId),
  });
